export enum MemberInviteStatuses {
  CreatedWithoutInvitation = "Created Without Invitation",
  InvitationSent = "Invitation Sent",
  InvitationAccepted = "Invitation Accepted",
}
